import { GRAPHQL_KNOWN_ERROR_CODES, GraphQLKnownErrorCodes } from '@/libs/apollo-client';
import { ApolloError } from '@apollo/client';

export const apolloIsKnownError = (error: ApolloError) => {
    return (
        error.graphQLErrors.length > 0 &&
        GRAPHQL_KNOWN_ERROR_CODES.includes(error.graphQLErrors[0].extensions?.code as GraphQLKnownErrorCodes)
    );
};
